import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelM, Title6 } from 'atoms/typography';
import { hideScrollbar } from 'style/utils';

const Root = styled.article`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  color: var(--c-neutral-1000);
  border-radius: var(--double-unit);
  background: var(--c-neutral-200);
  padding: var(--double-unit);
`;
const Header = styled.header`
  display: flex;
  gap: var(--unit);
`;
const Items = styled(Horizontal).attrs({ gap: 2 })`
  ${hideScrollbar}
  scroll-snap-type: x mandatory;
  margin: 0 calc(-1 * var(--double-unit));
  padding: 0 var(--double-unit);
  overflow: auto;
`;

type Props = {
  label?: ReactNode;
  length?: number;
  children: ReactNode;
};
export const MatchupStatus = ({ label, length, children }: Props) => {
  const displayLength = typeof length === 'number';
  return (
    <Root>
      {label ||
        (displayLength && (
          <Header>
            {label && <Title6>{label}</Title6>}
            {displayLength && length > 0 && (
              <Title6 color="var(--c-neutral-600)">{length}</Title6>
            )}
          </Header>
        ))}
      {displayLength && length === 0 ? (
        <LabelM as="span" color="var(--c-neutral-600)">
          <FormattedMessage
            id="rivals.MatchupStatus.emptyState"
            defaultMessage="No challenge for this match"
          />
        </LabelM>
      ) : (
        <Items>{children}</Items>
      )}
    </Root>
  );
};
